// extracted by mini-css-extract-plugin
module.exports = {"teamMemberVwq":"TeamMembers_teamMemberVwq__3fq0M"};